export default __webpack_public_path__ + "static/media/Personaje-Banner1.43ee9498.png";